import { gameInstance } from '@Game/GameComponent';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { IPowerLine, IWinningLine } from '@GFTypes/GameStoreTypes';
import { IActionResponseStep } from '@GFTypes/Responses/ActionResponse';
import { IStepExtension } from '../Responses/SpinResponseProcessor';
import { buildSelectionMaskFromPositions } from '../Utils/Utils';
import { getPositionsFromWinningLine } from './WinDataProcessor';

export const getCorrectWallMultiplier = (originalMultiplier: number | undefined, wallSymbolId: number): number | undefined => {
    if (!originalMultiplier) return undefined;
    const symbolConfig = gameInstance.gameStore.get(EGameStoreKeys.AuthenticateGameConfig).symbols[0].find((symbol) => symbol.symbolId === wallSymbolId)!;
    const paytable = symbolConfig.paytable[0] ?? [];
    let highestPaytableMultiplier = 0;
    paytable.multiplier.forEach((multiplier) => {
        if (multiplier > highestPaytableMultiplier) highestPaytableMultiplier = multiplier;
    });
    return originalMultiplier / highestPaytableMultiplier;
};

export const getPowerLinesForWallWin = (
    step: IActionResponseStep,
    stepExtension: IStepExtension,
    finalWallMultiplier: number | undefined
): IPowerLine[] | undefined => {
    const numberOfReels = step.finalSymbols.length;
    const positions = getAllPositions(stepExtension.visibleSymbols);
    const selectionMask = buildSelectionMaskFromPositions(positions, stepExtension.visibleSymbols);

    const powerLines: IPowerLine[] = [
        {
            numberOfReels,
            numberOfLines: Math.pow(stepExtension.visibleSymbols[0].length, stepExtension.visibleSymbols.length),
            positions,
            win: step.win,
            symbolId: step.finalSymbols[0][1],
            selectionMask,
            winMessageMultiplier: finalWallMultiplier ?? 1
        }
    ];

    return powerLines;
};

export const getWinLinesForWallWin = (step: IActionResponseStep, stepExtension: IStepExtension, finalWallMultiplier: number | undefined): IWinningLine[] => {
    const { payLines } = gameInstance.gameStore.get(EGameStoreKeys.AuthenticateGameConfig);
    const numberOfReels = step.finalSymbols.length;

    return payLines.map((payline, id) => {
        const positions = getPositionsFromWinningLine(payline, numberOfReels, 1);
        return {
            id,
            symbolsCount: numberOfReels,
            win: step.win / payLines.length,
            direction: 1,
            positions: positions,
            symbolId: stepExtension.visibleSymbols[0][0],
            selectionMask: buildSelectionMaskFromPositions(positions, stepExtension.visibleSymbols),
            winMessageMultiplier: finalWallMultiplier ?? 1
        };
    });
};

const getAllPositions = (visibleSymbols: number[][]): [number, number][] => {
    const positions: [number, number][] = [];

    for (let i = 0; i < visibleSymbols.length; i++) {
        for (let j = 0; j < visibleSymbols[i].length; j++) {
            positions.push([i, j]);
        }
    }

    return positions;
};
